import classNames from 'clsx';
import webviewTitleCoverImage from 'img/quota-landing/blackFriday2024/webviewTitle.png';
import CyberMonday2025WebviewTitleCoverImage from 'img/quota-landing/cyberMonday2025/webviewTitle.png';
import React, { memo, useCallback } from 'react';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { autumnPromo } from 'reactApp/appHelpers/featuresHelpers/features/autumnPromo';
import { blackFriday2024 } from 'reactApp/appHelpers/featuresHelpers/features/blackFriday2024';
import { cyberMonday2025 } from 'reactApp/appHelpers/featuresHelpers/features/cyberMonday2025';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { Button } from 'reactApp/ui/Button/Button';
import { renderMobileDiscountsModal } from 'reactApp/ui/Mobile/DiscountsModal/DiscountsModal.helpers';

import styles from './Header.css';

type HeaderProps = {
    septemberPromo2025Enabled?: boolean;
    blackFriday2025Enabled?: boolean;
    marchPromo2026Enabled?: boolean;
    summerPromo2026Enabled?: boolean;
};

export const Header = memo<HeaderProps>(
    ({ septemberPromo2025Enabled, blackFriday2025Enabled, marchPromo2026Enabled, summerPromo2026Enabled }) => {
        const onActionClick = useCallback(() => {
            sendQuotaGa({ action: 'action', label: 'click' });
            renderMobileDiscountsModal({ isRebrandingQuotaLanding });
        }, []);

        return (
            <div
                className={classNames(styles.root, {
                    [styles.root_rebranding]: isRebrandingQuotaLanding,
                    [styles.root_autumnPromo]: autumnPromo,
                    [styles.root_cyberMonday2025]: cyberMonday2025,
                    [styles.root_marchPromo2026]: marchPromo2026Enabled,
                })}
            >
                <div
                    className={classNames(styles.title, {
                        [styles.titleSeptemberPromo2025Mobile]: septemberPromo2025Enabled || blackFriday2025Enabled,
                    })}
                >
                    {summerPromo2026Enabled ? (
                        <div className={styles.titleSummerPromo2026Mobile}>
                            <span>Тарифы Mail Space</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="128" height="7" viewBox="0 0 128 7" fill="none">
                                <path
                                    d="M1.70563 4.25528C46.2146 -2.40949 125.832 5.11234 125.832 5.11234"
                                    stroke="#B8FC75"
                                    strokeWidth="3"
                                    strokeLinecap="square"
                                />
                            </svg>
                        </div>
                    ) : (
                        <>
                            Тарифы <br /> Mail Space
                        </>
                    )}
                    {blackFriday2024 && <img src={webviewTitleCoverImage} className={styles.webviewTitleImage} alt="cover image" />}
                    {cyberMonday2025 && (
                        <img src={CyberMonday2025WebviewTitleCoverImage} className={styles.webviewTitleImage} alt="cover image" />
                    )}
                </div>
                <Button
                    className={classNames(styles.button, {
                        [styles.buttonSeptemberPromo2025Mobile]: septemberPromo2025Enabled || blackFriday2025Enabled,
                    })}
                    onClick={onActionClick}
                >
                    Акции
                </Button>
            </div>
        );
    }
);

Header.displayName = 'Header';
